<nav aria-label="Main navigation">
  <ul>
    <li>
      <a
        [routerLink]="['/home']"
        routerLinkActive="router-link-active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <div fxLayout="row" fxLayoutAlign="start center">
          <mat-icon>home</mat-icon>
          <span class="first-level">Home</span>
        </div>
      </a>
    </li>
    <li>
      <a
        [routerLink]="['/teams']"
        routerLinkActive="router-link-active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <div fxLayout="row" fxLayoutAlign="start center">
          <mat-icon>people</mat-icon>
          <span class="first-level">{{ 'Teams' | platformLabel }}</span>
        </div>
      </a>
    </li>
    <li>
      <a
        [routerLink]="['/people']"
        routerLinkActive="router-link-active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <div fxLayout="row" fxLayoutAlign="start center">
          <mat-icon>person</mat-icon>
          <span class="first-level">People</span>
        </div>
      </a>
    </li>
    <li>
      <a
        [routerLink]="['/reports']"
        routerLinkActive="router-link-active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <div fxLayout="row" fxLayoutAlign="start center">
          <mat-icon>summarize</mat-icon>
          <span class="first-level">Reports</span>
        </div>
      </a>
    </li>
    @if (isAdmin()) {
      <li>
        <a
          [routerLink]="['/admin']"
          routerLinkActive="router-link-active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div fxLayout="row" fxLayoutAlign="start center">
            <mat-icon>settings</mat-icon>
            <span class="first-level">Admin</span>
          </div>
        </a>
      </li>
    }
  </ul>
</nav>
<mat-divider></mat-divider>
<nav aria-label="Support links">
  <ul>
    <li>
      <button (click)="openWidget()">Support</button>
    </li>
    <li>
      <a
        href="https://www.lineupteams.com/privacy-policy"
        target="_blank"
        [attr.title]="'Privacy Policy'"
      >
        Privacy Policy
      </a>
    </li>
    <li>
      <a
        href="https://support.lineupteams.com/hc/en-us/sections/360006008474-Release-Notes"
        target="_blank"
        [attr.title]="'Release Notes'"
      >
        Release Notes
      </a>
    </li>
  </ul>
</nav>
